import { render, staticRenderFns } from "./addedit.vue?vue&type=template&id=89761c4a"
import script from "./addedit.vue?vue&type=script&lang=js"
export * from "./addedit.vue?vue&type=script&lang=js"
import style0 from "./addedit.vue?vue&type=style&index=0&id=89761c4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports